import type { PylotFrontendConfig } from '../config.d'
export const config: PylotFrontendConfig = {
    base: {
        url: {
            baseUrl: 'https://me.ooka.com/ar/',
            magentoBaseUrl: 'https://mcstaging.hookah-shisha.com/',
            model: {
                category: { directory: 'c', suffix: '' },
                product: { suffix: '.html', directory: 'p' },
                cmsPage: { directory: 'content', suffix: '' },
                blog: { directory: 'blog' }
            },
            externalShishaworldurl: 'https://www.shisha-world.com/',
            mediaBackend: { enabled: true, baseMediaUrl: '' }
        },
        menu: { submenu: 'subcategory', submenu_maxitems: 10 },
        wishlist: {
            enabled: true,
            multiple_wishlists: false,
            multiple_wishlist_number: 5
        },
        yotpo: {
            enabled: true,
            api_key: 'JTo76PyJ1Qp8ovM6adBBQBD4FaKGNCZBEFD2Mz5M'
        },
        yotpoLoyalty: {
            enabled: true,
            guid: 'TDlduWRGdBlJghBylpEAuQ',
            widget_ids: {
                checkoutPopup: '351426',
                checkoutRedeem: '354836',
                myAccountPage: [
                    '326987',
                    '326990',
                    '351427',
                    '326989',
                    '326988'
                ],
                rewardsPage: '326985',
                referralsPage: '326989'
            }
        },
        signifyd: { enabled: false },
        landingpage: { enabled: false },
        loqate: {
            enabled: false,
            findEndPoint:
                'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
            retrieveEndPoint:
                'https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws',
            validateEndPoint:
                'https://api.addressy.com/Cleansing/International/Batch/v1.00/json4.ws',
            api_key: 'DC88-CU47-NX37-MH99'
        },
        spreedlyPaymentMethod: {
            enabled: true,
            environment_key: 'FcnSDHHrqbvNoarHer6WuN9xULf',
            scriptLink: 'https://core.spreedly.com/checkout/sdk/1.6.2/index.js',
            sri:
                'sha384-RIyE3OUuYKNGQTpBRH1lHnuedS6yrvAlQEmprA2tgC4owK+gTfWqFr+8zEMiZN/N'
        },
        klarna: {
            enabled: false,
            scriptLink: 'https://x.klarnacdn.net/kp/lib/v1/api.js',
            allowedCountries: ['DE']
        },
        gReCaptcha: {
            token: '6LdT1i8pAAAAAIB8gKw6tJ7h5gQ-3NOibwyH_2LY',
            enabled: true
        },
        vr: { enabled: false },
        veratad: { enabled: false },
        reorderAllow: true,
        socialLogin: {
            google: {
                enabled: false,
                clientId:
                    '907838138612-ee7vdov07o748kak35fp9a128uao414n.apps.googleusercontent.com'
            },
            facebook: { enabled: false, appId: '1322564722031148' }
        },
        restrictedArea: { areaCodes: [] },
        sentry: {
            enabled: true,
            dsn:
                'https://850534629e2a19f08c878d6aad1b0ab8@o4510222596440064.ingest.de.sentry.io/4510312712372304'
        },
        magentoBaseUrl: 'https://mcadmin.hookah-shisha.com/',
        googleSiteVerificationContent:
            'Siimw5PmEhha31-qzxk8aNWznmHwy1rHGGtJiI4AacY',
        otherWebsiteUrls: {
            ooka_us: 'https://us.ooka.com/',
            ooka_ae: 'https://me.ooka.com/',
            ooka_de: 'https://de.ooka.com/',
            ooka_glp: 'https://ooka.com/'
        },
        route: { cms_no_route: 'no-route', cms_home_page: 'home' },
        mida: { enabled: true, key: '1rZ95mgaRyZMmBeyvJKlzx' },
        showTitle: true,
        hubspot: {
            enabled: true,
            portalId: '25636661',
            formId: '502873f2-5ae3-4f2a-ae8d-25292033532b',
            chatUrl: '//js-eu1.hs-scripts.com/25636661.js'
        },
        googleAnalytics: { containerID: 'UA-253970242-1' },
        paymentWidgets: {
            tabby: {
                enabled: true,
                publicKey: 'pk_test_bbb3091d-d019-45d2-9adc-fd4a3979e2f1'
            },
            tamara: {
                enabled: true,
                publicKey: '0b69b821-1ac3-4525-a8ae-d7d91b7d9d7b'
            }
        }
    },
    preload: {
        menu: {
            queryPath:
                'framework/pylot/hooks/category/graphql/navigationMenuWithCMSBlocks.ts',
            variables: { category_uid: 'MjY0MA==', onlyTopLevel: true }
        },
        header: {
            variables: { identifiers: ['shipping-promo-banner'] },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        footer: {
            variables: {
                identifiers: [
                    'footer-copyright-block',
                    'footer_links',
                    'footer-social-media',
                    'footer_payment_split',
                    'unique-selling-proposition-slider',
                    'footer-secure-payment'
                ]
            },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts',
            role: {
                copyright: 'footer-copyright-block',
                links: 'footer_links',
                social: 'footer-social-media',
                unique: 'unique-selling-proposition-slider',
                securePayment: 'footer-secure-payment'
            }
        },
        countries: {
            variables: {},
            queryPath:
                'components/alfakher/pylot-utils/src/hooks/graphql/countryQuery.ts'
        },
        checkoutBlocks: {
            variables: {
                identifiers: [
                    'checkout_alfa_consent',
                    'account_creation_benefit',
                    'checkout_review_block'
                ]
            },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        blogBlocks: {
            variables: {
                identifiers: [
                    'sidebar-banner-1',
                    'blog_shop_now',
                    'you_may_also_like'
                ]
            },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        MyDevice: {
            variables: { identifiers: ['my-devices'] },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        CheckoutAgreements: {
            variables: {},
            queryPath:
                'framework/pylot/hooks/cms/graphql/getCheckoutAgreement.ts'
        },
        thca_disclaimer: {
            variables: { identifiers: ['thca_disclaimer'] },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        GiftWrapping: { isEnabled: false, identifiers: ['gift_cart_Message'] }
    },
    seo: {
        default: {
            title:
                'أول شيشة إلكترونية في العالم بدون فحم خلال 5 دقائق فقط  | OOKA',
            titleTemplate: 'Ooka ME | %s',
            description:
                'استمتع بكبسولات الشيشة من دون فحم لأجواء رائعة اليوم مع OOKA. طريقة سريعة ونظيفة ومريحة للاستمتاع بالشيشة.',
            openGraph: {
                type: 'website',
                locale: 'en_US',
                url: 'https://me.ooka.com/ar/',
                site_name: 'Ooka ME',
                images: [
                    {
                        url:
                            'https://media.ooka.com/media/wysiwyg/logo/OokaLogo.png',
                        alt: 'Ooka ME'
                    }
                ]
            },
            twitter: {
                handle: '@ooka',
                site: 'Ooka ME',
                cardType: 'summary_large_image'
            }
        },
        product: {
            attributes: {
                name: ['name'],
                description: ['description', 'html'],
                image: ['media_gallery', '0', 'url'],
                price_amount: [
                    'price_range',
                    'minimum_price',
                    'final_price',
                    'value'
                ],
                price_currency: [
                    'price_range',
                    'minimum_price',
                    'final_price',
                    'currency'
                ],
                review_count: ['review_count'],
                review_summary: ['review_summary'],
                gtin: ['gtin'],
                brand: ['brand'],
                manufacturer: ['manufacturer'],
                model: ['model'],
                sku: ['sku'],
                mpn: ['mpn'],
                seller: ['seller'],
                alternate_name: ['alternate_name']
            },
            image: {
                count: 1,
                width: 620,
                placeholder:
                    'https://mcadmin.hookah-shisha.com/media/wysiwyg/MicrosoftTeams-image_4_.png'
            },
            description: {
                regExp: '^[\\n|\\n\\r]+Details[\\n|\\n\\r]+',
                maxLength: 1000
            },
            price: { currency: 'USD', precision: 2, validUntilDays: 14 },
            defaultBrand: 'Ooka Products',
            bestRating: 5
        },
        organization: {
            content: {
                '@context': 'https://schema.org',
                '@type': 'Organization',
                legalname: 'OOKA HEATING DEVICES LLC',
                address: {
                    '@type': 'PostalAddress',
                    streetAddress:
                        'Suite 700, 7th Floor, Festival Office Tower',
                    addressLocality: 'Dubai Festival City',
                    addressRegion: 'Dubai',
                    postalCode: '00000'
                },
                url: 'https://me.ooka.com/en/',
                logo: 'https://media.ooka.com/media/wysiwyg/logo/OokaLogo.png',
                name: 'OOKA HEATING DEVICES LLC',
                email: 'me.customercare@ooka.com',
                contactPoint: [
                    {
                        telephone: '+971-4-292-3000',
                        contactType: 'customer service',
                        contactOption: 'TollFree'
                    }
                ],
                sameAs: [
                    'https://www.instagram.com/ooka.arabia',
                    'https://www.facebook.com/ooka.arabia',
                    'https://www.tiktok.com/@ooka.arabia?lang=en',
                    'https://www.youtube.com/channel/UCg1ZBV80uF4zTC82khCDehA'
                ]
            },
            allowedPath: '/'
        },
        customPages: {
            account: {
                pageName: 'My Account',
                pageType: 'account',
                children: {
                    orders: {
                        pageName: 'My Account | Orders',
                        pageType: 'account-orders'
                    },
                    wishlist: {
                        pageName: 'My Account | Wishlist',
                        pageType: 'account-wishlist'
                    },
                    address: {
                        pageName: 'My Account | Address',
                        pageType: 'account-address'
                    },
                    'account-information': {
                        pageName: 'My Account | Account Information',
                        pageType: 'account-information'
                    },
                    'store-credit': {
                        pageName: 'My Account | Store Credit',
                        pageType: 'account-store-credit'
                    },
                    newsletter: {
                        pageName: 'My Account | Newsletter Subscription',
                        pageType: 'account-newsletter'
                    },
                    'gift-card': {
                        pageName: 'My Account | Gift Card',
                        pageType: 'account-gift-card'
                    }
                }
            },
            search: { pageName: 'Search page', pageType: 'searchresults' },
            checkout: { pageName: 'Checkout page', pageType: 'checkout' }
        },
        checkoutSteps: {
            cart: 1,
            login: 2,
            signup: 2,
            shipping: 3,
            payment: 4
        },
        tagManager: { gtm: { enabled: true, containerId: 'GTM-KBNQPP8' } },
        searchBox: {
            allowedPath: '/',
            potentialActions: [
                {
                    target: 'https://me.ooka.com/ar/search?q',
                    queryInput: 'search_term_string'
                }
            ]
        }
    },
    static: {
        categories: { count: 100, root: 'ooka-uae' },
        products: { count: 100 }
    },
    is_fallback: false
}
